import type { ReactNode } from "react";

export function LegalPage({ title, intro, children }: { title: string; intro: string; children: ReactNode }) {
  return (
    <main className="bg-background">
      <header className="bg-ocean-900 px-4 py-10 text-ocean-50 sm:px-6 sm:py-16 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h1 className="font-heading text-3xl font-extrabold sm:text-4xl">{title}</h1>
          <p className="mt-4 text-base leading-relaxed text-ocean-100 sm:text-lg">{intro}</p>
        </div>
      </header>
      <section className="px-4 pb-16 pt-6 sm:px-6 sm:pb-20 sm:pt-10 lg:px-8">
        <div className="mx-auto w-full max-w-4xl">{children}</div>
      </section>
    </main>
  );
}